
import { MentorEdit } from '../../profile/Mentor';
import { MenteeEdit } from '../../profile/Mentee';

import { useUser } from '../../Components/UserProvider';

export default function ProfileEdit() {
    const user = useUser();
    if (user.mentor_profile) {
        return <MentorEdit
            id={user.id}
        />
    }

    return <MenteeEdit
        id={user.id}
    />
}
